export const PLATFORM_ADMIN = 1;
